"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var AdvUserMessagesComponent = /** @class */ (function () {
    function AdvUserMessagesComponent() {
    }
    AdvUserMessagesComponent.prototype.ngOnInit = function () {
    };
    return AdvUserMessagesComponent;
}());
exports.AdvUserMessagesComponent = AdvUserMessagesComponent;
